import { gql, useQuery } from '@apollo/client';
import { useState } from 'react';

export const GET_APPLICANTS_BY_VACANCY = gql`
  query getApplicantsByVacancy(
    $vacancyId: ObjectId!
    $filters: FilterApplicantsInput!
    $queryOptions: QueryOptionsInput!
  ) {
    getApplicantsByVacancy(vacancyId: $vacancyId, filters: $filters, queryOptions: $queryOptions) {
      collection {
        _id
        firstName
        lastName
        email
        phoneNumber
        status
        createdAt
        documents {
          resumeFiles {
            _id
            filename
            location
          }
          salutationFiles {
            _id
            filename
            location
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetApplicantsByVacancy = (vacancyId: string, statuses?: any) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'createdAt', sortBy: -1 },
  ]);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_APPLICANTS_BY_VACANCY, {
    variables: {
      vacancyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
      filters: {
        statuses,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { collection = [], totalCount = 0 } = data?.getApplicantsByVacancy || {};

  return {
    loading,
    applicants: collection,
    paginationConfig: {
      pageSize,
      total: totalCount,
      current: currentPage,
      onChange: (page: number) => setCurrentPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      const sortArray = [];

      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        sortArray.push({ field: 'createdAt', sortBy });
      }

      setNameSort(sortArray);
    },
  };
};
